import { type Context } from "@opentelemetry/api";
import type { ReadableSpan, Span, SpanProcessor } from "@opentelemetry/sdk-trace-base";

import type { Metas } from "@grafana/faro-web-sdk";

// adds Faro session id to every span
export class FaroSessionSpanProcessor implements SpanProcessor {
  constructor(private processor: SpanProcessor, private metas: Metas) {}

  forceFlush(): Promise<void> {
    return this.processor.forceFlush();
  }

  onStart(span: Span, parentContext: Context): void {
    const session = this.metas.value.session;
    const user = this.metas.value.user;
    const pageurl = this.metas.value.page?.url;
    const hostname = location.hostname;

    if (session?.id) {
      span.attributes["session_id"] = session.id;
    }
    if (user?.id && user?.id !== "") {
      span.attributes["user_id"] = user.id;
    }
    if (pageurl && pageurl !== "") {
      span.attributes["page_url"] = pageurl;
    }
    if (hostname && hostname !== "") {
      span.attributes["hostname"] = hostname;
    }

    this.processor.onStart(span, parentContext);
  }

  onEnd(span: ReadableSpan): void {
    const responseContentLength = span.attributes["http.response_content_length"];
    const responseContentLengthUncompressed = span.attributes["http.response_content_length_uncompressed"];
    const contentLength = responseContentLength?.toString();
    const contentLengthUncompressed = responseContentLengthUncompressed?.toString();

    if (contentLength !== undefined && contentLength.length > 8) {
      span.attributes["http.response_content_length"] = 0;
      span.attributes["http.response_content_length_invalid"] = true;
    }
    if (contentLengthUncompressed !== undefined && contentLengthUncompressed.length > 8) {
      span.attributes["http.response_content_length_uncompressed"] = 0;
      span.attributes["http.response_content_length_uncompressed_invalid"] = true;
    }
    this.processor.onEnd(span);
  }

  shutdown(): Promise<void> {
    return this.processor.shutdown();
  }
}
